function Header(props){
    return (
        <header id="header">
            {props.children}
       </header>
    );
};

export default Header;